import React from "react";
import { motion } from "framer-motion";
const Home = () => {
  const testimonials = [
    {
      image: "./Images/img5.png",
      name: "Aditi Sharma",
      designation: "B.Tech Student.",
      feedback:
        "MAD Advisors made my university application process smooth and stress-free. Their guidance was invaluable!",
    },
    {
      image: "./Images/img5.png",
      name: "Rahul Mehra",
      designation: "MBA Student",
      feedback:
        "Thanks to MAD Advisors, I secured admission to my dream university with a scholarship!",
    },
  ];
  const steps = [
    {
      id: 1,
      title: "Initial Consultation",
      description:
        "We begin by understanding the student’s academic background and career aspirations.",
    },
    {
      id: 2,
      title: "Career Assessment",
      description: "Comprehensive evaluations using psychometric tests",
    },
    {
      id: 3,
      title: "University and Course Shortlisting",
      description:
        "Identifying the best-fit universities and courses based on preferences.",
    },
    {
      id: 4,
      title: "Application Preparation",
      description:
        "Crafting a powerful application with SOPs, LORs, and resumes.",
    },
    {
      id: 5,
      title: "Exam Preparation Strategy",
      description: "Personalized study schedules and practice resources.",
    },
    {
      id: 6,
      title: "Financial Aid Guidance",
      description: "Support with scholarships and loan applications",
    },
    {
      id: 7,
      title: "Admission Success",
      description:
        "Assistance with offer acceptance and admission formalities.",
    },
    {
      id: 8,
      title: "Post-Admission Support",
      description: "Placement assistance and ongoing career counseling.",
    },
  ];
  const examCategories = [
    {
      title: "Engineering Entrance Exams",
      exams: ["IIT-JEE (JEE Main & Advanced)"],
      icon: "fas fa-laptop-code",
    },
    {
      title: "Architecture Entrance Exams",
      exams: ["NATA (National Aptitude Test in Architecture)"],
      icon: "fas fa-drafting-compass",
    },
    {
      title: "Design Entrance Exams",
      exams: ["UCEED (Undergraduate Common Entrance Exam for Design)"],
      icon: "fas fa-palette",
    },
    {
      title: "Management Entrance Exams",
      exams: ["CAT", "XAT", "MAT"],
      icon: "fas fa-chart-line",
    },
    {
      title: "Medical Entrance Exams",
      exams: ["NEET (National Eligibility cum Entrance Test)"],
      icon: "fas fa-stethoscope",
    },
    {
      title: "Law Entrance Exams",
      exams: ["CLAT (Common Law Admission Test)"],
      icon: "fas fa-balance-scale",
    },
    {
      title: "International Entrance Exams",
      exams: ["GMAT", "GRE"],
      icon: "fas fa-globe",
    },
    {
      title: "Other Specialized Exams",
      exams: ["Support for various other industry-specific entrance exams"],
      icon: "fas fa-book-open",
    },
  ];
  const services = [
    {
      icon: "fas fa-globe",
      title: "Personalized Career Counseling",
      description:
        "We provide several choices of destinations and very affordable travel packages.",
    },
    {
      icon: "fas fa-user-tie",
      title: "University and Course Selection",
      description:
        "We provide professional tour guides who are experienced and knowledgeable.",
    },
    {
      icon: "fas fa-ticket-alt",
      title: "Admission Application Assistance",
      description:
        "Easily book tickets or reserve your favorite travel spots with just a few clicks.",
    },
    {
      icon: "fas fa-hotel",
      title: "Entrance Exam Preparation Support",
      description:
        "We ensure top-quality accommodations that make your trip relaxing and enjoyable.",
    },
  ];

  const sentenceVariant = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        delay: 0.5,
        staggerChildren: 0.3, // Delay between words
      },
    },
  };

  const wordVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const AnimatedText = ({ text, className }) => {
    return (
      <motion.div
        className={className}
        variants={sentenceVariant}
        initial="hidden"
        animate="visible">
        {text.split(" ").map((word, index) => (
          <motion.span
            key={index}
            variants={wordVariant}
            style={{ display: "inline-block", marginRight: "5px" }}>
            {word}
          </motion.span>
        ))}
      </motion.div>
    );
  };
  return (
    <>
      <section className="home-banner">
        <div className="overlay">
          <div className="container">
            <div className="row align-items-center">
              {/* Left Content */}
              <div className="col-lg-6 col-md-8 col-12">
                <AnimatedText
                  text="Welcome to MAD Advisors – Your Trusted Career Guide"
                  className="banner-title"
                />
                <AnimatedText
                  text=" We guide students toward a brighter future with expert counseling and seamless admission support."
                  className="banner-text"
                />
                <motion.button
                  className="btn btn-primary"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 1.5 }}>
                  Get Started
                </motion.button>
              </div>

              {/* Right Registration Form */}
              <div className="col-lg-5 col-md-8 col-12 offset-lg-1 mt-4 mt-lg-0 mt-4">
                <div className="registration-form p-4 shadow bg-white">
                  <h4 className="mb-3 fw-bold">Register Now</h4>
                  <form className="form-container">
                    <div className="mb-3">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your name"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone No.</label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Enter your phone number"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Message</label>
                      <textarea
                        className="form-control"
                        rows="4"
                        placeholder="Type your message"
                        required></textarea>
                    </div>
                    <button type="submit" className="btn btn-primary w-100">
                      Sign Up
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-who-we-are py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* About Us - Left */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2 className="section-title">About Us</h2>
              <p className="section-text">
                At MAD Advisors, we are passionate about guiding students
                towards a brighter future by helping them make informed
                decisions for their undergraduate and postgraduate studies. With
                our expert counseling, comprehensive university information, and
                personalized support, we make the admission journey seamless and
                stress-free.
              </p>
            </div>

            {/* About Us - Right Image */}
            <div className="col-lg-6 img-container position-relative">
              <div className="grid-pattern"></div>
              <img
                src="./Images/img6.png"
                alt="About Us"
                className="img-fluid custom-img"
              />
            </div>
          </div>

          {/* Who We Are Section */}
          <div className="row align-items-center mt-5">
            {/* Who We Are - Left Image */}
            <div className="col-lg-6 img-container position-relative">
              <div className="grid-patterntwo"></div>
              <img
                src="./Images/img1.png"
                alt="Who We Are"
                className="img-fluid custom-img mb-5"
              />
            </div>

            {/* Who We Are - Right */}
            <div className="col-lg-6">
              <h2 className="section-title">Who We Are</h2>
              <p className="section-text">
                MAD Advisors stands for Mentorship, Advice, and Direction. We
                are a premier career guidance consultancy with headquarters in
                Jaipur and branch offices in Dehradun and Kolkata. Our mission
                is to empower students with the right knowledge and resources to
                choose the best educational path tailored to their aspirations.
              </p>
            </div>
          </div>

          {/* Vision & Mission Section Beneath Who We Are */}
          <div className="row justify-content-center mt-4">
            <div className="col-md-5">
              <div className="vision-mission-box compact-box mb-2">
                <div className="icon-box">
                  <i className="fas fa-eye"></i>
                </div>
                <div>
                  <h4 className="text-muted fw-bold">Our Vision</h4>
                  <p>
                    To be the most trusted career guidance platform, enabling
                    students to unlock their full potential and achieve their
                    academic dreams.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-5">
              <div className="vision-mission-box compact-box mb-2">
                <div className="icon-box">
                  <i className="fas fa-bullseye"></i>
                </div>
                <div>
                  <h4 className="text-muted fw-bold">Our Mission</h4>
                  <p>
                    To provide personalized, expert guidance that helps students
                    make informed decisions and gain admission to top
                    universities, fostering success and lifelong learning.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="services py-5">
        <div className="container">
          {/* Section Heading */}
          <div className="text-center mb-4">
            <h5 className="section-subtitle">What We Offer</h5>
            <h2 className="section-title">Our Comprehensive Services</h2>
            <p className="section-text">
              We are dedicated to providing the best experience with top-notch
              services.
            </p>
          </div>

          {/* Service Cards */}
          <div className="row">
            {services.map((service, index) => (
              <div key={index} className="col-lg-3 col-md-6 mb-4">
                <div className="service-card text-center p-4">
                  <div className="icon-wrapper">
                    <i className={service.icon}></i>
                  </div>
                  <h4 className="service-title">{service.title}</h4>
                  <p className="service-description">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="exams-section">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Section - Introduction */}
            <div className="col-lg-5 left-section">
              <h5 className="section-subtitle">What We Cover</h5>
              <h2 className="section-title">Competitive Exams We Cover</h2>
              <p className="section-text">
                We provide specialized coaching and resources for India's top
                entrance exams. Our expert faculty, updated study material, and
                personalized mentorship ensure success across multiple
                disciplines.
              </p>
            </div>

            {/* Right Section - Exams Grid */}
            <div className="col-lg-7">
              <div className="exams-grid">
                {examCategories.map((category, index) => (
                  <div key={index} className="exam-card">
                    <i className={category.icon}></i>
                    <h4>{category.title}</h4>
                    <ul>
                      {category.exams.map((exam, idx) => (
                        <li key={idx}>{exam}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="services-section">
        <div className="parallax-bg">
          <div className="overlay"></div>
          <div className="container">
            <div className="row gap-5 justify-content-center text-white">
              {/* Psychometric Assessment Services */}
              <div className="col-lg-5 service-box mb-4 text-start">
                <h2 className="section-title">
                  Psychometric Assessment Services
                </h2>
                <p className="section-text">
                  We provide <strong>free psychometric assessments</strong> to
                  help students understand their{" "}
                  <strong>strengths, aptitudes, and interests</strong>. These
                  scientifically designed tests guide students towards the{" "}
                  <strong>most suitable career paths</strong>.
                </p>
                <ul className="benefits-list text-start">
                  <li>
                    <i className="fas fa-user-check"></i> Gain insights into
                    personality traits and career inclinations.
                  </li>
                  <li>
                    <i className="fas fa-lightbulb"></i> Make informed decisions
                    based on strengths and preferences.
                  </li>
                  <li>
                    <i className="fas fa-file-alt"></i> Receive a detailed
                    report with expert analysis.
                  </li>
                </ul>
                <button className="btn btn-primary">Take the Assessment</button>
              </div>

              {/* Scholarship & Financial Aid Guidance */}
              <div className="col-lg-5 service-box mb-4 text-start">
                <h2 className="section-title">
                  Scholarship & Financial Aid Guidance
                </h2>
                <p className="section-text">
                  We offer expert assistance in securing{" "}
                  <strong>scholarships and financial aid</strong>, making
                  quality education more accessible.
                </p>
                <ul className="benefits-list text-start">
                  <li>
                    <i className="fas fa-award"></i> Detailed info on
                    merit-based, need-based, and special scholarships.
                  </li>
                  <li>
                    <i className="fas fa-edit"></i> Assistance with scholarship
                    applications and crafting strong essays.
                  </li>
                  <li>
                    <i className="fas fa-piggy-bank"></i> Guidance on education
                    loans, interest rates, and repayment plans.
                  </li>
                </ul>
                <button className="btn btn-secondary">
                  Explore Scholarships
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="infographic-section py-5">
        <div className="container">
          <div className="row text-center">
            {/* Overseas Education Support */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="info-card shadow p-4">
                <i className="fas fa-globe-americas info-icon"></i>
                <h3 className="info-title">Overseas Education Support</h3>
                <p className="info-text">
                  Guidance on universities, visa applications, and cultural
                  adaptation.
                </p>
              </div>
            </div>

            {/* Career Pathway Planning */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="info-card shadow p-4">
                <i className="fas fa-chart-line info-icon"></i>
                <h3 className="info-title">Career Pathway Planning</h3>
                <p className="info-text">
                  Explore career fields, industry trends, and roadmap for
                  success.
                </p>
              </div>
            </div>

            {/* Placement Assistance */}
            <div className="col-lg-4 col-md-12 mb-4">
              <div className="info-card shadow p-4">
                <i className="fas fa-briefcase info-icon"></i>
                <h3 className="info-title">Placement Assistance</h3>
                <p className="info-text">
                  Internships, job placements, and professional development
                  support.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="why-choose-us py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side: Text Content */}
            <div className="col-lg-6">
              <h5 className="section-subtitle">Why Us?</h5>
              <h2 className="fw-bold mb-4">Why Choose MAD Advisors?</h2>
              <ul className="list-unstyled">
                <li className="d-flex align-items-center mb-3">
                  <i className="fas fa-user-tie fa-2x me-3 "></i>
                  <p className="mb-0">
                    <strong>Expert Counselors:</strong> Our team comprises
                    seasoned education and industry experts.
                  </p>
                </li>
                <li className="d-flex align-items-center mb-3">
                  <i className="fas fa-university fa-2x me-3 "></i>
                  <p className="mb-0">
                    <strong>Vast University Network:</strong> Partnerships with
                    top national and international institutions.
                  </p>
                </li>
                <li className="d-flex align-items-center mb-3">
                  <i className="fas fa-user-cog fa-2x me-3 "></i>
                  <p className="mb-0">
                    <strong>Tailored Guidance:</strong> Customized solutions for
                    every student’s unique needs.
                  </p>
                </li>
                <li className="d-flex align-items-center mb-3">
                  <i className="fas fa-laptop-code fa-2x me-3 "></i>
                  <p className="mb-0">
                    <strong>Technology-Driven Solutions:</strong> Advanced tools
                    for application tracking and career analytics.
                  </p>
                </li>
                <li className="d-flex align-items-center">
                  <i className="fas fa-hands-helping fa-2x me-3 "></i>
                  <p className="mb-0">
                    <strong>Holistic Support:</strong> Comprehensive assistance
                    covering every aspect of career planning and university
                    admissions.
                  </p>
                </li>
              </ul>
            </div>

            {/* Right Side: Image */}
            <div className="col-lg-6 img-container position-relative">
              {/* Background Grid */}
              <div className="grid-pattern"></div>

              {/* Main Image */}
              <img
                src="./Images/img4.png"
                alt="About Us"
                className="img-fluid custom-img mb-3"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="process-section py-5">
        <div className="container">
          <h5 className="section-subtitle text-center">Our Processes</h5>
          <h2 className="section-title text-center mb-5">
            Our Process for Success
          </h2>
          <div className="row justify-content-center">
            {steps.map((step) => (
              <div
                key={step.id}
                className="col-md-3 col-sm-6 mb-3 d-flex justify-content-center">
                <div className="process-card text-center">
                  <div className="process-circle">{step.id}</div>
                  <h4 className="process-title">{step.title}</h4>
                  <p className="process-description">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="testimonials-section py-5">
        <div className="container">
          {/* Section Heading */}
          <div className="text-center mb-4">
            <h5 className="section-subtitle">Testimonials</h5>
            <h2 className="testimonials-title">What Our Students Say</h2>

            <p className="text-white mt-2">
              Hear from our successful students about their journey with us.
            </p>
          </div>

          {/* Bootstrap Carousel */}
          <div
            id="testimonialCarousel"
            className="carousel slide"
            data-bs-ride="carousel">
            <div className="carousel-inner">
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className={`carousel-item ${index === 0 ? "active" : ""}`}>
                  <div className="testimonial-card text-center p-4">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="testimonial-img mb-3"
                    />
                    <p className="testimonial-feedback">
                      "{testimonial.feedback}"
                    </p>
                    <h4 className="testimonial-name">{testimonial.name}</h4>
                    <p className="testimonial-designation">
                      {testimonial.designation}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Carousel Controls */}
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#testimonialCarousel"
              data-bs-slide="prev">
              <span className="carousel-control-prev-icon"></span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#testimonialCarousel"
              data-bs-slide="next">
              <span className="carousel-control-next-icon"></span>
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
